import LocationInfo from './LocationInfo';
import ReviewCard from './ReviewCard';

export default {
  LocationInfo,
  ReviewCard,
};
